<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-toolbar-title class="toolbar-logo">
      <i v-if="dealerViewingUser"
        ><img
          alt="1"
          style="height: 100%; width: 160px; max-height: 6vh"
          svg-inline
          src="@/assets/svg/3xLogo.svg"
      /></i>
      <i
        v-else
        @click="routeToDashboard"
        class="icon-hover"
        data-testid="navigation-logo"
        ><img
          alt="2"
          style="height: 100%; width: 160px"
          svg-inline
          src="@/assets/svg/3xDealerPortalLogo.svg"
      /></i>
    </v-toolbar-title>
    <v-tabs
      height="6.5vh"
      model="tab"
      slider-color="red"
      slider-size="4"
      :optional="navTabsOptional"
      v-model="tabsModel"
      :hide-slider="navTabsOptional"
    >
      <v-tab
        to="/dashboard"
        active-class="nav-active"
        v-if="!dealerViewingUser"
        data-testid="navigation-dashboard"
      >
        <i><img alt="3" svg-inline src="@/assets/svg/dashboard.svg" /></i>
        {{ $t('navigation.dashboard') }}
      </v-tab>
      <v-tab
        to="/customers"
        active-class="nav-active"
        v-if="!dealerViewingUser"
        data-testid="navigation-customers"
      >
        <v-icon x-small class="mr-1">$customerManagementIcon</v-icon>
        {{ $t('navigation.customerManagement') }}
      </v-tab>
      <v-tab
        to="/admin"
        active-class="nav-active"
        v-if="!dealerViewingUser && showDealerMyUsers"
        data-testid="navigation-users"
      >
        <i>
          <img
            alt="4"
            svg-inline
            class="gear-icon-tweak"
            src="@/assets/svg/gear.svg"
          />
        </i>
        {{ $t('navigation.administration') }}
      </v-tab>
      <v-tab
        to="/locations"
        active-class="nav-active"
        v-if="dealerViewingUser"
        data-testid="navigation-locations"
      >
        <v-icon color="white" size="14">mdi-map-marker</v-icon>
        {{ $t('navigation.locations') }}
      </v-tab>
    </v-tabs>
    <v-spacer></v-spacer>
    <AccountMenu />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'

export default defineComponent({
  name: 'DealerUserDesktopNav',
  props: {
    dealerViewingUser: {
      type: Boolean,
      required: true,
    },
    showDealerMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tabsModel: null,
    }
  },
  components: {
    AccountMenu,
  },
  methods: {
    routeToDashboard() {
      this.$router.push('/dashboard')
    },
  },
  watch: {
    checkTabsModel() {
      if (this.navTabsOptional) this.tabsModel = ''
    },
  },
  computed: {
    checkTabsModel() {
      return this.navTabsOptional
    },
  },
})
</script>
